import { faClose, FaIcon } from '@/lib/fa'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const EditGroupHeader = ({
  name,
  close,
}: {
  name: string
  close: () => void
}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
      <div className="tw-flex tw-flex-col tw-gap-2">
        <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
          {t('driverModule.group')} - {name}
        </p>
        <p className="tw-text-sm tw-text-content-base/80">
          {t('driverModule.add-or-remove-drivers')}
        </p>
      </div>
      <FaIcon
        icon={faClose}
        className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
        onClick={() => close()}
      />
    </div>
  )
}

export default EditGroupHeader
